const BASE_ENDPOINT = '/health-insurance-service/resources/';

function mountEndpoint(endpoint: string, prefix: string = BASE_ENDPOINT): string {
  return `${prefix}${endpoint}`;
}

const GET = {

  INFORMATION: mountEndpoint('information'),
  MY_DATA_USER: mountEndpoint('my-data/user'),

  WSUITE: mountEndpoint('wsuite'),
  REPORTS: mountEndpoint('reports/list'),

  TECHNICAL_VISIT_AVAILABLE_DATES: mountEndpoint('technical-visit/available-dates'),
  TECHNICAL_VISIT: mountEndpoint('technical-visit'),
  TECHNICAL_VISIT_FORM: mountEndpoint('technical-visit-questionnaires/autocomplete/:nrSeqQuestion'),
  TECHNICAL_VISIT_ADDITIONAL_INFORMARTION_DOWNLOAD: mountEndpoint('technical-visit-form/:nrSeqVisit/attachment/:nrSequence/download'),
  TECHNICAL_VISIT_QUESTIONNAIRE_STATUS: mountEndpoint('technical-visit-form/:nrSeqVisit/form/:nrSeqForm/status'),
  TECHNICAL_VISIT_DETAILS_REPORT: mountEndpoint('technical-visit-details/:nrSeqVisit/report'),

  MAP_ADDRESS: mountEndpoint('map/:nrSeqProvider'),

  HEALTH_DECLARATION_VALIDATE: mountEndpoint('health-declaration/validate/:hash'),
  HEALTH_DECLARATION_TERM: mountEndpoint('health-declaration/term/:nrSeqTerm'),
  HEALTH_DECLARATION_TERM_GENERIC: mountEndpoint('health-declaration/term/generic'),
  HEALTH_DECLARATION_USER_INFO: mountEndpoint('health-declaration/user-info'),
  HEALTH_DECLARATION_QUESTIONNAIRE: mountEndpoint('questionnaires/:nrSeqModel'),
  HEALTH_DECLARATION_QUESTIONNAIRE_DATA: mountEndpoint('health-declaration/questionnaires/:nrSeqType'),
  HEALTH_DECLARATION_QUESTIONNAIRE_REPLIES: mountEndpoint('questionnaires/:nrSeqDeclaration/replies'),

  DISCREDITED_PROVIDER_PARAMS: mountEndpoint('discredited-providers/params'),
  DISCREDITED_PROVIDER_DETAIL: mountEndpoint('discredited-providers/detail/:nrSeqProvider'),
  GUIDE_LEGENDS: mountEndpoint('discredited-providers/legends'),

  PRODUCTS_BY_USER: mountEndpoint('products-by-user'),

  REPORT_BY_GROUP: mountEndpoint('reports/:cdGroup'),
  REPORT_BY_PATH: mountEndpoint('reports/path/:path'),
  TERMS: mountEndpoint('/terms'),
};

const POST = {
  AUDIT_FUNCTION: mountEndpoint('/audit/function'),
  REPORT: mountEndpoint('reports'),
  REFRESH: mountEndpoint('authentication'),
  REVOKE: mountEndpoint('logout'),

  HEALTH_DECLARATION_CODE_VALIDATION: mountEndpoint('health-declaration/validate/code'),
  HEALTH_DECLARATION_SUBMIT: mountEndpoint('health-declaration/submit'),
  HEALTH_DECLARATION_QUESTIONNAIRE_DATA: mountEndpoint('questionnaires/:seqInsuredDeclaration/save/:nmUser'),

  UPLOAD_FILE: mountEndpoint('files/upload'),

  TECHNICAL_VISIT_ADDITIONAL_INFORMARTION: mountEndpoint('technical-visit-form/:nrSeqVisit/attachment'),
  TECHNICAL_VISIT_QUESTIONNAIRE: mountEndpoint('/technical-visit-questionnaires/:nrSeqVisit'),
  START_TECHNICAL_VISIT: mountEndpoint('technical-visit-form/:nrSeqVisit/form/:nrSeqForm/start'),
  FINISH_TECHNICAL_VISIT: mountEndpoint('technical-visit-form/:nrSeqVisit/form/:nrSeqForm/finish'),

  DISCREDITED_PROVIDER_LIST: mountEndpoint('discredited-providers/list'),

  TERMS: mountEndpoint('/terms'),

};

const PUT = {
  SEND_MAIL: mountEndpoint('mail'),
};

export const ENDPOINTS: { GET: typeof GET; PUT: typeof PUT; POST: typeof POST; } = { GET, PUT, POST };
